import { paginaClientes } from './clientes.js';
import { mostrarToastm, obtenerUrlBackend } from './utilerias.js';


export function paginaclientePartsTab(clienteId) {


    const URL_BASE_API = obtenerUrlBackend('8083');
    const URL_BASE = `${URL_BASE_API}/api/clienteArticulos`;
    const URL_API = `${URL_BASE}/${clienteId}`;

    const URL_METRICAS_MENSUALES = `${URL_BASE_API}/api/datosCliente/${clienteId}`;


    const html = `<div class="container my-4">
        <div id="estado-contenedor" class="alert alert-info" role="alert">
            <p id="mensaje-estado" class="mb-0">Cargando datos del servidor...</p>
        </div>

       <section id="seccion-encabezado" class="mb-4 d-none">            
            <div id="contenedor-encabezado" class="row">
                <div class="col-12 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-header-custom p-3 text-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-4"> 
                            <div class="d-flex align-items-center gap-4 flex-wrap">
                                <a href="javascript:void(0)" id="btn-regresar-tableros" class="text-white" title="Regresar a Tableros">
                                    <i class="fa-solid fa-lg fa-arrow-left icon-back"></i>
                                </a>
                                <span id="hdr-cliente" class="fw-bold style-code">N/A</span>
                                <a href="javascript:void(0)" class="text-primary link-grafica" data-bs-toggle="modal" data-bs-target="#cte-modalGraficaSelector" title="Ver métricas mensuales">
                                    <i class="fa-solid fa-chart-line icon-chart text-white"></i>
                                </a>
                                <span id="hdr-name-cliente" class="style-name">N/A</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 mb-3">
                    <div class="card shadow-sm h-100">
                        <div class="card-body metrics-container border-bottom"> 
                            <div class="metric-box">
                                <p class="metric-label">Posición (Cliente):</p>
                                <strong id="hdr-posicion-cliente" class="metric-value">N/A</strong>
                            </div>
                            <div class="metric-box">
                                <p class="metric-label">% Vta:</p>
                                <strong id="hdr-porc-vta" class="metric-value">N/A</strong>
                            </div>
                            <div class="metric-box">
                                <p class="metric-label">% Vta Acum:</p>
                                <strong id="hdr-porc-vta-acum" class="metric-value">N/A</strong>
                            </div>
                            <div class="metric-box">
                                <p class="metric-label">CVPM (Metros):</p>
                                <strong id="hdr-cvpm-metros" class="metric-value">N/A</strong>
                            </div>
                            <div class="metric-box">
                                <p class="metric-label">Importe Promedio:</p>
                                <strong id="hdr-importe-prom" class="metric-value">N/A</strong>
                            </div>
                            <div class="metric-box">
                                <p class="metric-label">Partes:</p>
                                <strong id="hdr-tot-partes" class="metric-value">N/A</strong>
                            </div>
                            <div class="metric-box">
                                <p class="metric-label">Precio Promedio:</p>
                                <strong id="hdr-precio-prom" class="metric-value">N/A</strong>
                            </div>
                            <div class="metric-box">
                                <p class="metric-label">Estilos:</p>
                                <a href="#" id="link-estilos" data-bs-toggle="modal" data-bs-target="#modalEstilos">
                                    <strong id="hdr-tot-estilos" class="metric-value">N/A</strong>
                                </a>
                            </div>
                        </div>

                        <div class="card-body py-3">
                            <div class="row g-3">
                                <div class="col-12">
                                    <div class="card shadow-sm card-inferior w-100">
                                        <div class="card-header card-header-azul text-center fw-bold">
                                            Total Cliente-Articulos
                                        </div>
                                        
                                        <div class="card-body metrics-container">
                                            
                                            <div class="metric-box">
                                                <p class="metric-label">CVPM Metros:</p>
                                                <strong id="hdr-tot_cvpm_metros_d" class="metric-value">N/A</strong>
                                            </div>

                                            <div class="metric-box">
                                                <p class="metric-label">CVPM Importe:</p>
                                                <strong id="hdr-tot_cvpm_importe" class="metric-value">N/A</strong>
                                            </div>

                                            <div class="metric-box">
                                                <p class="metric-label">Porcentaje:</p>
                                                <strong id="hdr-tot_porc_det" class="metric-value">N/A</strong>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="seccion-detalle" class="mb-4 d-none">          
            <div class="table-responsive">            
                <table id="tabla-detalles" class="table table-striped table-hover border">
                    <thead class="table-secondary">
                        <tr>
                            <th>Num</th>
                            <th>Clave</th>
                            <th>Descripción</th>
                            <th>CVPM metros</th>
                            <th>CVPM Importe</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        </section>
    </div>

    <div class="modal fade modal-corporativo" id="modalEstilos" data-bs-backdrop="false" tabindex="-1">
        <div class="modal-dialog modal-lg"> 
            <div class="modal-content">
                <div class="modal-header"> 
                    <h5 class="modal-title">Estilos Relacionados:</h5>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>               
                </div>
                <div class="modal-body">
                    <table id="tabla-estilos" class="table table-striped table-hover border w-100"></table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>

   <div class="modal modal-corporativo" id="cte-modalGraficaSelector" data-bs-backdrop="false" tabindex="-1" aria-labelledby="cte-modalGraficaSelectorLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="d-flex align-items-center">
                        <h5 class="modal-title" id="cte-modalGraficaSelectorLabel">Selección de Métricas Mensuales</h5>
                        <button type="button" class="btn btn-sm btn-outline-light ms-3" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#cte-cont-seleccion-metricas" 
                            aria-expanded="false" 
                            aria-controls="cte-cont-seleccion-metricas">
                            <i class="fa-solid fa-sliders me-1"></i> Parámetros
                        </button>
                    </div>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div id="cte-cont-seleccion-metricas" class="collapse border-bottom pb-3 mb-3">
                        <div class="card card-body bg-light">
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <h6><i class="fa-solid fa-calendar-range"></i> Rango de Periodo:</h6>
                                    <div class="row mb-3">
                                        <div class="col-12 col-sm-6 mb-2">
                                            <label for="cte-fecha-inicio" class="form-label small">Desde:</label>
                                            <input type="month" id="cte-fecha-inicio" class="form-control">
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <label for="cte-fecha-fin" class="form-label small">Hasta:</label>
                                            <input type="month" id="cte-fecha-fin" class="form-control">
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2 fw-bold text-center" style="font-size: 0.8rem; color: #666;">
                                    <div class="col-6 text-start">Concepto</div>
                                    <div class="col-3">Promedio</div>
                                    <div class="col-3">Real</div>
                                </div>
                                <div id="cte-lista-metricas-checkboxes"></div>
                            </div>

                            <div class="text-end mt-3">
                                <button type="button" class="btn btn-success btn-sm" id="btn-gen-grafctes">
                                    <i class="fa-solid"></i> Generar Gráfica
                                </button>
                            </div>
                        </div>
                    </div>

                    <div style="height: 400px; width: 100%;">
                        <canvas id="grafica-seleccionada"></canvas>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
    `;

    
    setTimeout(() => {
        obtenerYRenderizarDatosCliente(URL_API, clienteId); 
        obtDatosParaGraficaCte(URL_METRICAS_MENSUALES, clienteId);

        const btnRegresar = document.getElementById('btn-regresar-tableros');

        if (btnRegresar) {
            btnRegresar.addEventListener('click', (e) => {
                e.preventDefault();
                const lienzo = document.querySelector('.content');

                if (lienzo) {
                    lienzo.innerHTML = paginaClientes();
                }
            });
        }
    }, 100);

    return html;
}




// ID de la tabla de DETALLES
const ID_TABLA = '#tabla-detalles'; 
let datosMensualesGlobal = [];
let datosEstilosGlobal = []; 

async function obtenerYRenderizarDatosCliente(url, clienteId) {
    const mensajeEstado = document.getElementById('mensaje-estado');
    if (!url) {
        mensajeEstado.textContent = "❌ ERROR: No se recibió la URL.";
        return;
    }
    
    mensajeEstado.textContent = `Cargando detalles del Cliente ${clienteId}...`;

    try {

        const token = sessionStorage.getItem('token_teresita');

        // Hace petición al servidor
        const respuesta = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token, // pase temporal
                'Content-Type': 'application/json'
            }
        });

        // Verifica
        if (!respuesta.ok) {
            if (respuesta.status === 401 || respuesta.status === 403) {
                throw new Error("Sesión inválida o expirada. Por favor, inicia sesión de nuevo.");
            }
            throw new Error(`Error en el servidor: ${respuesta.status}`);
        }


        const cajaGrande = await respuesta.json();
        
        const encabezado = cajaGrande.encabezado;
        const detalles = cajaGrande.detalles || [];
        const estilos = cajaGrande.estilos || []; 

        datosEstilosGlobal = estilos; 

        if (detalles.length === 0) {
             mensajeEstado.textContent = `⚠️ No hay detalles para el Cliente ${clienteId}.`;
             return;
        }

        renderizarEncabezado(encabezado, estilos);
        inicializarDataTable(detalles);

        mensajeEstado.textContent = `✅ Cliente ${clienteId}: ${detalles.length} registros.`;
        configurarModalEstilos();

    } catch (error) {
        console.error("Fallo:", error);
        mostrarToast(error.message, 'warning'); 
    }
}

async function obtDatosParaGraficaCte(url, clienteId) {
    const mensajeEstado = document.getElementById('mensaje-estado');
    try {
        const token = sessionStorage.getItem('token_teresita');
        // Hace petición al servidor
        const respuesta = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': token, // pase temporal
                'Content-Type': 'application/json'
            }
        });

        // Verifica
        if (!respuesta.ok) {
            if (respuesta.status === 401 || respuesta.status === 403) {
                throw new Error("Sesión inválida o expirada. Por favor, inicia sesión de nuevo.");
            }
            throw new Error(`Error en el servidor: ${respuesta.status}`);
        }

        const resultado = await respuesta.json();
        const datosParaUsar = resultado || [];

        if (datosParaUsar.length === 0) {
             mensajeEstado.textContent = `⚠️ No hay detalles para el Cliente.`;
             return;
        }
        datosMensualesGlobal = datosParaUsar;
        configModalGraficaCte(datosMensualesGlobal);
       

    } catch (error) {
        console.error("❌ Error en la obtención de datos:", error);
    }
}

// =========================================================
// FUNCIÓN NUEVA: Renderizar el Encabezado
// =========================================================
function renderizarEncabezado(data, estilos) {

    const getFormattedNumber = (value, decimals = 2, prefix = '', isPercentage = false) => {
            if (value === null || value === undefined) {
                return 'N/A';
            }
            
            const num = parseFloat(value); 
            if (isNaN(num)) {
                return 'N/A';
            }
            
            let finalNum = num;
            let suffix = '';

            
            if (isPercentage) {
                
                let precision = (decimals > 0) ? decimals : 0;
                
                if (decimals === 2 && num === Math.round(num)) {
                    precision = 0;
                }
                return finalNum.toFixed(precision) + '%'; 
            }
            
            
            let formatOptions = {};
            
            if (decimals > 0) {
                
                formatOptions = { 
                    minimumFractionDigits: decimals, 
                    maximumFractionDigits: decimals 
                };
            } else {
                
                formatOptions = { 
                    maximumFractionDigits: 0 
                };
            }
            
            const formattedNum = finalNum.toLocaleString('es-MX', formatOptions);
            
            return prefix + formattedNum + suffix;
        };
    
    const totalEstilos = estilos.length;
    
    // Mapeo de campos del encabezado SQL 
    const mapeoEncabezado = {
        'hdr-cliente': data.vp_cte_addr,
        'hdr-name-cliente': data.name,
        'hdr-posicion-cliente': data.posicion_cliente,
        
        'hdr-importe-prom': getFormattedNumber(data.importe_prom, 2, '$'),
        'hdr-cvpm-metros': getFormattedNumber(data.cvpm_metros, 0), 
        'hdr-tot-partes': data.num_partes,
        'hdr-precio-prom': getFormattedNumber(data.precio_prom, 2, '$'),
        
        'hdr-porc-vta': getFormattedNumber(data.porc_vta, 2),
        'hdr-porc-vta-acum': getFormattedNumber(data.porc_vta_acum, 2),

        'hdr-tot_cvpm_metros_d': getFormattedNumber(data.tot_cvpm_metros_d, 0),
        'hdr-tot_cvpm_importe': getFormattedNumber(data.tot_cvpm_importe, 2),
        'hdr-tot_porc_det': getFormattedNumber(data.tot_porc_det, 2, '', true),
        'hdr-tot-estilos': data.num_estilos
        
       
    };

 
    Object.keys(mapeoEncabezado).forEach(id => {
        const elemento = document.getElementById(id);
        if (elemento) {
            elemento.textContent = mapeoEncabezado[id];
        }
    });

    const linkEstilos = document.getElementById('link-estilos');
    if (linkEstilos) {
        linkEstilos.style.pointerEvents = totalEstilos > 0 ? 'auto' : 'none';
        linkEstilos.style.color = totalEstilos > 0 ? 'inherit' : '#888';
    }

    document.getElementById('seccion-encabezado').classList.remove('d-none');
    document.getElementById('seccion-detalle').classList.remove('d-none');
}

$.fn.dataTable.ext.search.push(
    function(settings, data, dataIndex) {
        
        const numericTitles = [
            'CVPM metros', 
            'CVPM Importe', 
            '%', 
            'Importe Cte', 
            '% Cte'
        ];
        
        
        const api = new $.fn.dataTable.Api(settings);
        const headers = api.columns().header().toArray();
        
        
        for (let i = 0; i < headers.length; i++) {
            const title = $(headers[i]).text().trim();
            
            
            if (!numericTitles.includes(title)) {
                continue;
            }

            
            const cellData = data[i]; 
            const filtroInput = $(headers[i]).find('input').val() || ''; 
            
            const match = filtroInput.match(/^([<>=]+)\s*([\d.,]+)$/);
            
            if (!match) {
                continue;
            }


            const operator = match[1];
            let numFilter = match[2];
            
            const numData = parseFloat(cellData.replace(/[^0-9.-]+/g, ''));
            numFilter = parseFloat(numFilter.replace(/[^0-9.-]+/g, ''));

            if (isNaN(numData) || isNaN(numFilter)) {
                return false; 
            }

            let result = false;
            switch (operator) {
                case '>': result = numData > numFilter; break;
                case '<': result = numData < numFilter; break;
                case '>=': result = numData >= numFilter; break;
                case '<=': result = numData <= numFilter; break;
                case '=': result = numData === numFilter; break;
            }
            
            if (!result) {
                return false;
            }
        }
        
        return true;
    }
);

// =========================================================
// FUNCIÓN NUEVA: Inicializar DataTables para Estilos
// =========================================================
function inicializarTablaEstilos(datos) {
    
    const columnasDefEstilos = [
        { data: 'posicion_estilo', title: 'Num' },
        { data: 'estilo', title: 'Clave' },
        { data: 'desc', title: 'Descripción' },
        { 
            data: 'cvpm_metro', 
            title: 'CVPM Metro',
            render: $.fn.dataTable.render.number( ',', '.', 0, '' ) 
        },
        { 
            data: 'monto_metros', 
            title: 'Monto Metros',
            render: $.fn.dataTable.render.number( ',', '.', 2, '$' ) 
        },
        { 
            data: 'porcentaje', 
            title: '% Total',
            render: function(data) {
                const num = parseFloat(data);
                if (isNaN(num)) return 'N/A';
                return num.toFixed(0) + '%'; 
            }
        }
    ];

    $('#tabla-estilos').DataTable({
        data: datos,
        columns: columnasDefEstilos,
        destroy: true,
        paging: true,
        searching: true,
        lengthChange: false,
        pageLength: 10,
        responsive: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
        },
        dom: 'rtip', 
        
        initComplete: function() {
            
        }
    });
    
}

// =========================================================
// FUNCIÓN: Configurar evento del Modal
// =========================================================

export function configurarModalEstilos() {

    const modal = document.getElementById('modalEstilos');
    
    if (modal) {

        modal.addEventListener('show.bs.modal', function (event) {
        inicializarTablaEstilos(datosEstilosGlobal);
        modal.focus(); 
            
        });
    }       
}


// =========================================================
// FUNCIÓN CLAVE: Inicializar DataTables con datos de Detalle
// =========================================================
function inicializarDataTable(datos)  {

    const storageKey = `DataTables_filtros_cliente`;
    
    const columnasDef = [
        
        { data: 'posicion', title: 'Num' },
        { data: 'clave', title: 'Clave' },
        { data: 'descripcion', title: 'Descripción' },
        { 
            data: 'cvpm_metros_d', 
            title: 'CVPM metros',
            render: $.fn.dataTable.render.number( ',', '.', 0, '' ) 
        },
        { 
            data: 'cvpm_importe_d', 
            title: 'CVPM Importe',
            render: $.fn.dataTable.render.number( ',', '.', 2, '$' ) 
        },
        { 
            data: 'porcentaje_detalle', 
            title: '%',
            render: function(data) { 
                const num = parseFloat(data);   
                return (isNaN(num) || data === null) ? '0.00%' : num.toFixed(0) + '%'; 
            }
        }
    ];

    
    var table = $(ID_TABLA).DataTable({
        data: datos,
        columns: columnasDef,
        retrieve: true,
        destroy: true,
        stateSave: true,
        stateDuration: -1,
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json"
        },
        lengthChange: true,
        pageLength: 50,
        lengthMenu: [[10, 25, 50, 100, -1],[10, 25, 50, 100, "Todos"]],
        aria: {
                "sortAscending": ": activar para ordenar columna ascendente",
                "sortDescending": ": activar para ordenar columna descendente"
            },
        dom: '<"row mb-3 align-items-center" <"col-sm-6"B> <"col-sm-6 text-end"l> >rt<"row" <"col-sm-6"i> <"col-sm-6"p> >',
         buttons: [
            { 
                extend: 'colvis', 
                text: '<i class="fas fa-binoculars fa-lg"></i> Columnas', 
                className: 'btn btn-sm',
                postfixButtons: [{
                    text: '<i class="fas fa-eye"></i> Mostrar Todas',
                    action: function (e, dt) { dt.columns().visible(true); }
                }]
            },
            {
                extend: 'collection',
                text: '<i class="fas fa-download"></i> Exportar', 
                className: 'btn btn-sm', 
                buttons: [
                    { extend: 'copy', text: '<i class="fas fa-copy"></i> Copiar', exportOptions: {columns: ':visible'} },
                    { extend: 'csv', text: '<i class="fas fa-file-csv"></i> CSV', exportOptions: {columns: ':visible'} },
                    { extend: 'excel', text: '<i class="fas fa-file-excel"></i> Excel', exportOptions: {columns: ':visible'} },
                    { extend: 'pdf', text: '<i class="fas fa-file-pdf"></i> PDF', orientation: 'landscape', exportOptions: {columns: ':visible'} },
                    { extend: 'print', text: '<i class="fas fa-print"></i> Imprimir', exportOptions: {columns: ':visible'} }
                ]
            },
            {
                text: '<i class="fas fa-filter"></i> Limpiar Filtros', 
                className: 'btn btn-sm',
                action: function (e, dt) {
                    dt.columns().every(function () {
                        
                        this.search(''); 
                        
                        $(this.header()).find('.filtro-columna').val(''); 
                    });
                        
                    localStorage.removeItem(storageKey);
                    
                    dt.draw();
                }
            }
        ],
       initComplete: function () {
            const api = this.api();
            const state = api.state.loaded();
            const numericTitles = ['CVPM metros', 'CVPM Importe', '%'];

            const filtrosOperadores = JSON.parse(localStorage.getItem(storageKey) || '{}');

            const pintarHeaders = () => {
                api.columns().every(function(index) {
                    const header = $(this.header());
                    header.removeClass('card-header-azul col-header-destacada');
                    if ([0, 1, 2, 3, 4,5].includes(index)) header.addClass('card-header-azul');
                });
            };
            pintarHeaders();
            api.on('column-visibility.dt', () => setTimeout(pintarHeaders, 0));


            api.columns().every(function (colIdx) {
                var column = this;
                var title = $(column.header()).text().trim();
                
                let placeholderText = 'Filtrar ' + title;
                const isNumeric = numericTitles.includes(title);
                
                if (isNumeric) {
                    placeholderText += ' (Ej: >100)';
                }
                
                var input = $('<input type="text" class="filtro-columna form-control form-control-sm" placeholder="' + placeholderText + '" />')
                    .appendTo($(column.header()));

                // ===== RESTAURA FILTROS =====
    
                if (state && state.columns[colIdx] && state.columns[colIdx].search.search) {
                    const valorGuardado = state.columns[colIdx].search.search;
                    const hasOperator = valorGuardado.match(/^[<>=]+/);
                    
                    if (isNumeric && hasOperator) {
                        filtrosOperadores[colIdx] = valorGuardado;
                        localStorage.setItem(storageKey, JSON.stringify(filtrosOperadores));
                        
                        input.val(valorGuardado);
                    } else {
                        input.val(valorGuardado);
                    }
                }
                
                if (filtrosOperadores[colIdx] && (!state || !state.columns[colIdx] || !state.columns[colIdx].search.search)) {
                    const valorOperador = filtrosOperadores[colIdx];
                    input.val(valorOperador);
                    setTimeout(() => {
                        column.draw();
                    }, 100);
                }

                // ===== MANEJAR EVENTOS DE FILTRO =====
                input.on('keyup change clear', function () {
                    const value = this.value;
                    const hasOperator = value.match(/^[<>=]+/);
                    const operadoresActuales = JSON.parse(localStorage.getItem(storageKey) || '{}');
                    
                    if (isNumeric && hasOperator) {
                        if (value === '') {
                            delete operadoresActuales[colIdx];
                        } else {
                            operadoresActuales[colIdx] = value;
                        }
                        localStorage.setItem(storageKey, JSON.stringify(operadoresActuales));
                        column.search('').draw();         
                    } else {
                        if (operadoresActuales[colIdx]) {
                            delete operadoresActuales[colIdx];
                            localStorage.setItem(storageKey, JSON.stringify(operadoresActuales));
                        }
                        if (column.search() !== value) {
                            column.search(value).draw();
                        }
                    }
                });
            });
            
            api.draw();
            document.getElementById('estado-contenedor').style.display = 'none';
        }
    });
}


function configModalGraficaCte(datos) {
    
    if (!datos || !Array.isArray(datos)) {
        //console.error("❌ ERROR: 'datos' no es una lista. Es:", typeof datos);
        mostrarToast('No hay datos para graficar.', 'warning');
        return; 
    }

    if (!datos || datos.length === 0) return;

    const nombresCampoUnicos = [...new Set(
        datos
            .map(item => item.nombre_campo)
            .filter(n => n && typeof n === 'string') 
    )];
    const anios = datos.map(item => item.anio);
    const minAnio = Math.min(...anios);
    const maxAnio = Math.max(...anios);

    const inputInicio = document.getElementById('cte-fecha-inicio');
    const inputFin = document.getElementById('cte-fecha-fin');
    const contenedorMetricas = document.getElementById('cte-lista-metricas-checkboxes');

    const guardado = JSON.parse(localStorage.getItem('cte-preferenciasGrafica')) || { metricas: [], fechaInicio: '', fechaFin: '' };

    inputInicio.value = guardado.fechaInicio || `${minAnio}-01`; 
    inputFin.value = guardado.fechaFin || `${maxAnio}-12`;

    const conceptos = [...new Set(nombresCampoUnicos.map(n => {
    const textoSeguro = n ? String(n) : ""; 
    return textoSeguro.replace(' Promedio', '').replace(' Real', '').trim();
    }))];


    contenedorMetricas.innerHTML = conceptos.map(concepto => {
        const nombrePromedio = `${concepto} Promedio`;
        const nombreReal = `${concepto} Real`;
        const checkProm = guardado.metricas.includes(nombrePromedio) ? 'checked' : '';
        const checkReal = guardado.metricas.includes(nombreReal) ? 'checked' : '';

        return `
            <div class="row align-items-center mb-2 border-bottom pb-1">
                <div class="col-6"><span class="fw-bold text-secondary" style="font-size: 0.9rem;">${concepto}</span></div>
                <div class="col-3 text-center">
                    <div class="form-check d-inline-block">
                        <input class="form-check-input cte-metrica-selector" type="checkbox" value="${nombrePromedio}" id="check-${nombrePromedio}" ${checkProm}>
                        <label class="form-check-label small" for="check-${nombrePromedio}"></label>
                    </div>
                </div>
                <div class="col-3 text-center">
                    <div class="form-check d-inline-block">
                        <input class="form-check-input cte-metrica-selector" type="checkbox" value="${nombreReal}" id="check-${nombreReal}" ${checkReal}>
                        <label class="form-check-label small" for="check-${nombreReal}"></label>
                    </div>
                </div>
            </div>`;
    }).join('');

    verificarYDibujarGraficaCte(minAnio, maxAnio);
}

function verificarYDibujarGraficaCte(min, max) {
    const guardado = JSON.parse(localStorage.getItem('cte-preferenciasGrafica'));
    const inputInicio = document.getElementById('cte-fecha-inicio');
    const inputFin = document.getElementById('cte-fecha-fin');

    if (guardado) {
        if (guardado.fechaInicio) inputInicio.value = guardado.fechaInicio;
        if (guardado.fechaFin) inputFin.value = guardado.fechaFin;
        
        if (guardado.metricas && guardado.metricas.length > 0) {
            setTimeout(() => {
                if (typeof generarGraficaCtes === 'function') {
                    generarGraficaCtes();
                }
            }, 400); 
        }
    } else if (min && max) {
        inputInicio.value = `${min}-01`;
        inputFin.value = `${max}-12`;
    }
}


export function generarGraficaCtes() {
    const fechaInicioStr = document.getElementById('cte-fecha-inicio').value; 
    const fechaFinStr = document.getElementById('cte-fecha-fin').value;
    const metricasSeleccionadas = Array.from(document.querySelectorAll('.cte-metrica-selector:checked')).map(cb => cb.value);

    if (!fechaInicioStr || !fechaFinStr || metricasSeleccionadas.length === 0) {
       
        mostrarToast('Selecciona un rango de fechas y al menos una métrica.', 'warning');
        return;
    }

    const vidrio = document.querySelector('.modal-backdrop');
    if (vidrio) vidrio.remove();
    document.body.classList.remove('modal-open');
    document.body.style.overflow = 'auto';

    const [anioI, mesI] = fechaInicioStr.split('-').map(Number);
    const [anioF, mesF] = fechaFinStr.split('-').map(Number);

    

    const fechaInicio = new Date(anioI, mesI - 1, 1);
    const fechaFin = new Date(anioF, mesF - 1, 1);

    if (fechaInicio > fechaFin) {
        mostrarToast('La fecha de inicio no puede ser mayor a la fecha de fin.', 'warning');
        return;
    }

    localStorage.setItem('cte-preferenciasGrafica', JSON.stringify({
        fechaInicio: fechaInicioStr,
        fechaFin: fechaFinStr,
        metricas: metricasSeleccionadas
    }));

    dibujarGraficaPorRangoCte(datosMensualesGlobal, metricasSeleccionadas, fechaInicio, fechaFin);
}

function dibujarGraficaPorRangoCte(datosCompletos, metricas, fInicio, fFin) {
    const ctx = document.getElementById('grafica-seleccionada').getContext('2d');
    const mesesNombres = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const mesesCortos = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

    let etiquetas = [];
    let periodos = [];
    let fActual = new Date(fInicio);

    while (fActual <= fFin) {
        const mesIndex = fActual.getMonth();
        const anio = fActual.getFullYear();
        etiquetas.push(`${mesesCortos[mesIndex]}-${anio}`);
        periodos.push({ mesNombre: mesesNombres[mesIndex], anio: anio });
        
        fActual.setMonth(fActual.getMonth() + 1);
    }

    const datasets = metricas.map((metrica, idx) => {
        const valores = periodos.map(p => {
            const fila = datosCompletos.find(d => d.nombre_campo === metrica && d.anio === p.anio);
            return fila ? parseFloat(fila[p.mesNombre]) : null;
        });

        const color = ['#FF6384', '#36A2EB', '#4BC0C0', '#FF9F40', '#9966FF'][idx % 5];
        return {
            label: metrica,
            data: valores,
            borderColor: color,
            backgroundColor: color,
            tension: 0.3,
            spanGaps: true
        };
    });

    if (window.miGrafica) window.miGrafica.destroy();
    window.miGrafica = new Chart(ctx, {
        type: 'line',
        data: { labels: etiquetas, datasets: datasets },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: { ticks: { maxRotation: 45, minRotation: 45 } }
            }
        }
    });
}